module.exports = "<div class=\"component-container\" ng-transclude></div>\n";